import type { ReduxStore } from '../../rootReducer'
import type { MapObjectIds } from '@mission.io/mission-toolkit'
import { isTransporterActive } from '../sharedSelectors'

export function getTransporterMapObject(store: ReduxStore): ?MapObjectIds {
	if (!isTransporterActive(store)) return null
	return store.jrPlusState.stationData.transporter.mapObject
}
